import { render } from "./Game.vue?vue&type=template&id=1c61c1ee&scoped=true&ts=true"
import script from "./Game.vue?vue&type=script&lang=ts"
export * from "./Game.vue?vue&type=script&lang=ts"

import "./Game.vue?vue&type=style&index=0&id=1c61c1ee&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c61c1ee"]])

export default __exports__